// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-layout {
  height: 10vh;
  display: grid;
  grid-template-columns: 20% 80%;
  background-color: #A5AAB1;
  color: white;
  align-items: center;
}

.gc-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 17px 40px;
  background: #fff;
  margin-bottom: 24px;
}
.gc-header .gc-breadcrumb ul {
  list-style: none;
}
.gc-header .gc-breadcrumb ul li {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 30px;
  color: #4B5563;
}
.gc-header .gc-breadcrumb ul li span {
  padding: 0 7px;
}
.gc-header .gc-breadcrumb ul li a {
  color: #2B3990;
}
.gc-header .gc-notification {
  position: relative;
  margin-right: 27px;
}
.gc-header .gc-notification span {
  width: 14px;
  height: 14px;
  color: #fff;
  font-size: 7px;
  background: #2B3990;
  position: absolute;
  top: -5px;
  right: -3px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}
.gc-header .gc-agency-avatar {
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 10px 0;
}
.gc-header .gc-agency-avatar .agency-img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff;
  color: #fff;
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  flex: 0 0 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.gc-header .gc-agency-avatar .agency-dropdown {
  position: absolute;
  top: 0;
  right: 0;
  background: #fff;
  width: 240px;
  border: 5px;
  z-index: 9;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px 10px;
}
.gc-header .gc-agency-avatar .agency-dropdown ul {
  list-style: none;
}
.gc-header .gc-agency-avatar .agency-dropdown ul li {
  border-bottom: 1px solid #FAFAFA;
  cursor: pointer;
  padding: 10px 16px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  min-height: 40px;
  position: relative;
}
.gc-header .gc-agency-avatar .agency-dropdown ul li:last-child {
  border-bottom: none;
}
.gc-header .gc-agency-avatar .agency-dropdown ul li .agency-icon {
  width: 20px;
  display: inline-block;
  flex: 0 0 20px;
}
.gc-header .gc-agency-avatar .agency-dropdown ul li span img {
  display: block;
}
.gc-header .gc-agency-avatar .agency-dropdown ul li .agency-roll-dropdown {
  position: absolute;
  right: 100%;
  top: 0;
  width: 240px;
  background: #fff;
  display: none;
}
.gc-header .gc-agency-avatar .agency-dropdown ul li .agency-roll-dropdown li a span::before {
  content: "";
  width: 5px;
  height: 5px;
  background: #1C75BC;
  border-radius: 50%;
  margin-right: 8px;
  display: inline-block;
  vertical-align: middle;
}
.gc-header .gc-agency-avatar .agency-dropdown ul li .agency-roll-dropdown li i {
  color: #10B981;
}
.gc-header .gc-agency-avatar .agency-dropdown ul li:hover, .gc-header .gc-agency-avatar .agency-dropdown ul li.active {
  background: #ECF0F5;
}
.gc-header .gc-agency-avatar .agency-dropdown ul li:hover .agency-roll-dropdown {
  display: block;
}
.gc-header .gc-agency-avatar .agency-dropdown ul li a {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #344054;
}
.gc-header .gc-agency-avatar .agency-dropdown ul li a div {
  display: flex;
  align-items: center;
  gap: 8px;
}
.gc-header .gc-agency-avatar .agency-dropdown ul li .gc-agency-name {
  font-size: 14px;
}
.gc-header .gc-agency-avatar .agency-dropdown ul li p.gc-agency-handle {
  font-size: 12px;
}
.gc-header .gc-agency-avatar .agency-dropdown ul li .gc-logout-btn a {
  color: #FF3C3C;
}
.hover-cursor {
  cursor: pointer;
}

.m-l-10 {
  margin-left: 10px;
}

.w-70 {
  width: 70%;
}

.align-right-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.align-center {
  display: flex;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/core/header/header.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,8BAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;AACF;;AACA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAEF;AAAK;EACC,gBAAA;AAEN;AADM;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAGR;AAFQ;EACE,cAAA;AAIV;AAFQ;EACE,cAAA;AAIV;AACE;EACE,kBAAA;EACA,kBAAA;AACJ;AAAI;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAEN;AACE;EACE,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AACJ;AAAI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAEN;AAAI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,4CAAA;EACA,wBAAA;AAEN;AADM;EACE,gBAAA;AAGR;AAFQ;EACE,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAIV;AAHU;EACE,mBAAA;AAKZ;AAHU;EACE,WAAA;EACA,qBAAA;EACA,cAAA;AAKZ;AAFY;EACE,cAAA;AAId;AADU;EACE,kBAAA;EACA,WAAA;EACA,MAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;AAGZ;AACkB;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;AACpB;AAGc;EACE,cAAA;AADhB;AAKU;EACE,mBAAA;AAHZ;AAMY;EACE,cAAA;AAJd;AAOU;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;AALX;AAMW;EACC,aAAA;EACA,mBAAA;EACA,QAAA;AAJZ;AAOU;EACE,eAAA;AALZ;AAOU;EACC,eAAA;AALX;AAQY;EACE,cAAA;AANd;AAmBA;EACE,eAAA;AAjBF;;AAoBA;EACE,iBAAA;AAjBF;;AAoBA;EACE,UAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,mBAAA;AAjBF","sourcesContent":[".header-layout{\n  height: 10vh;\n  display: grid;\n  grid-template-columns: 20% 80%;\n  background-color: #A5AAB1;\n  color: white;\n  align-items: center;\n}\n.gc-header{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 17px 40px;\n  background: #fff;\n  margin-bottom: 24px;\n  .gc-breadcrumb{\n     ul{\n      list-style: none;\n      li{\n        font-family: 'Montserrat';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 30px;\n        color: #4B5563;\n        span{\n          padding:0 7px;\n        }\n        a{\n          color: #2B3990;\n        }\n      }\n     }\n  }\n  .gc-notification{\n    position: relative;\n    margin-right:27px;\n    span{\n      width: 14px;\n      height: 14px;\n      color: #fff;\n      font-size: 7px;\n      background:#2B3990;\n      position: absolute;\n      top: -5px;\n      right: -3px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      border-radius: 50%;\n    }\n  }\n  .gc-agency-avatar{\n    position: relative;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    padding:10px 0;\n    .agency-img{\n      width: 40px;\n      height: 40px;\n      border-radius: 50%;\n      overflow: hidden;\n      background: #fff;\n      color: #fff;\n      text-align: center;\n      font-size: 15px;\n      font-weight: 600;\n      flex: 0 0 40px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n    .agency-dropdown {\n      position: absolute;\n      top: 0;\n      right: 0;\n      background: #fff;\n      width: 240px;\n      border: 5px;\n      z-index: 9;\n      box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);\n      border-radius: 10px 10px;\n      ul{\n        list-style: none;\n        li{\n          border-bottom: 1px solid #FAFAFA;\n          cursor: pointer;\n          padding: 10px 16px;\n          font-weight: 500;\n          font-size: 14px;\n          line-height: 20px;\n          min-height: 40px;\n          position: relative;\n          &:last-child{\n            border-bottom: none;\n          }\n          .agency-icon{\n            width:20px;\n            display: inline-block;\n            flex: 0 0 20px;\n          }\n          span{\n            img{\n              display: block;\n            }\n          }\n          .agency-roll-dropdown {\n            position: absolute;\n            right: 100%;\n            top: 0;\n            width: 240px;\n            background: #fff;\n            display: none;\n            li{\n              a{\n                span{\n                  &::before{\n                    content: '';\n                    width: 5px;\n                    height: 5px;\n                    background: #1C75BC;\n                    border-radius: 50%;\n                    margin-right: 8px;\n                    display: inline-block;\n                    vertical-align: middle;\n                  }\n                }\n              }\n              i{\n                color: #10B981;\n              }\n            }\n          }\n          &:hover,&.active{\n            background: #ECF0F5;\n          }\n          &:hover{\n            .agency-roll-dropdown{\n              display: block;\n            }\n          }\n          a{\n           display: flex;\n           justify-content: space-between;\n           align-items: center;\n           color: #344054;\n           div{\n            display: flex;\n            align-items: center;\n            gap: 8px;\n           }\n          }\n          .gc-agency-name{\n            font-size: 14px;\n          }\n          p.gc-agency-handle{\n           font-size: 12px;\n          }\n          .gc-logout-btn{\n            a{\n              color: #FF3C3C;\n            }\n          }\n        }\n      }\n  }\n  &:hover{\n      .agency-dropdown{\n      }\n    }\n  }\n}\n\n.hover-cursor {\n  cursor: pointer;\n}\n\n.m-l-10 {\n  margin-left: 10px;\n}\n\n.w-70 {\n  width: 70%;\n}\n\n.align-right-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.align-center {\n  display: flex;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
